import type { ComponentVariant } from './types';

export const DEFAULT_VARIANT: ComponentVariant = 'default';
export const ROOT_SCOPE = [];

export const SUB_COMPONENTS = Symbol('subComponents');
